import React, { useRef, useEffect, useLayoutEffect, useState } from "react";
import bg from "../../assets/images/stuff/bg.svg";
import profile1 from "../../assets/images/stuff/profiles.svg";
import style from "./Background.module.css";
import allContent from "../../allContent";

const Backgorund = ({ phase, setPhase, setButtonBottom }) => {
  const buttonRef = useRef(null);
  const divRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    window.onload = () => {
      if (divRef.current) {
        setButtonBottom(buttonRef.current.getBoundingClientRect().bottom + 20);
      }
    };
  }, []);

  return (
    <div
      className={style.background}
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
      }}
      ref={divRef}
    >
      <div className={style.textContainer}>
        <h2>{allContent.main.title1}</h2>
        <h1>{allContent.main.title2}</h1>
        <p>{allContent.main.text1}</p>
        <p>{allContent.main.text2}</p>
        <button
          className="mainButtonApp"
          ref={buttonRef}
          onPointerDown={() => {
            setPhase(1);
          }}
        >
          {allContent.main.button}
        </button>
      </div>
      <div className={style.images}>
        <img src={profile1} alt="profile1" className={style.profile1} />
      </div>
    </div>
  );
};

export default Backgorund;
